// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
let __webpack_exports__ = __webpack_require__.O(undefined, ["framework"], () => (__webpack_require__(44096)))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
